var map = {
	"./Home copy.vue": [
		29992,
		[
			9992
		]
	],
	"./Home.vue": [
		88735,
		[]
	],
	"./Notification.vue": [
		65679,
		[
			5679
		]
	],
	"./Notifications.vue": [
		67057,
		[]
	],
	"./Pos.vue": [
		30497,
		[]
	],
	"./account_settings/AccountDefaultSettings.vue": [
		80437,
		[
			437
		]
	],
	"./account_settings/BankAccount.vue": [
		46586,
		[]
	],
	"./account_settings/CostCenter.vue": [
		39758,
		[
			9758
		]
	],
	"./account_settings/FiscalYear.vue": [
		6022,
		[
			6022
		]
	],
	"./account_settings/TransactionEntryTypes.vue": [
		46239,
		[
			6239
		]
	],
	"./accounts/CustomerCollection.vue": [
		6987,
		[
			6987
		]
	],
	"./accounts/PayBills.vue": [
		11900,
		[
			1900
		]
	],
	"./accounts/SupplierLedger.vue": [
		16502,
		[]
	],
	"./accounts/VoucherEntry.vue": [
		45558,
		[
			5558
		]
	],
	"./accounts/VoucherEntryEdit.vue": [
		8121,
		[]
	],
	"./accounts/VoucherEntryList.vue": [
		60097,
		[
			97
		]
	],
	"./coa/AccountClass.vue": [
		20956,
		[
			956
		]
	],
	"./coa/AccountLedger.vue": [
		38716,
		[
			8716
		]
	],
	"./coa/AccountType.vue": [
		33309,
		[
			3309
		]
	],
	"./coa/ChartOfAccount.vue": [
		30503,
		[
			503
		]
	],
	"./coa/ChartOfAccountList.vue": [
		6223,
		[
			6223
		]
	],
	"./cogs_account_posting/COGSAccountPosting.vue": [
		88889,
		[
			8889
		]
	],
	"./dashboard/ApexchartBlock.vue": [
		33191,
		[]
	],
	"./dashboard/Topblock.vue": [
		28752,
		[]
	],
	"./dashboard/TopblockEmpty.vue": [
		85952,
		[]
	],
	"./drawer/Category.vue": [
		3973,
		[]
	],
	"./expire_product/ExpiryBoard.vue": [
		74250,
		[]
	],
	"./helper/Modal.vue": [
		97255,
		[]
	],
	"./inventory/InventoryBoard.vue": [
		222,
		[]
	],
	"./menu_and_permissions/ModuleOrMenu.vue": [
		30136,
		[]
	],
	"./menu_and_permissions/PermissionAction.vue": [
		68847,
		[]
	],
	"./page/About.vue": [
		3824,
		[
			3824
		]
	],
	"./page/AnalogWatch.vue": [
		33489,
		[]
	],
	"./page/Area.vue": [
		50361,
		[
			361
		]
	],
	"./page/AttributeValue.vue": [
		79340,
		[]
	],
	"./page/Attributes.vue": [
		10899,
		[]
	],
	"./page/Brand.vue": [
		68506,
		[]
	],
	"./page/BrandBackup.vue": [
		39909,
		[
			9909
		]
	],
	"./page/Colors.vue": [
		91777,
		[]
	],
	"./page/Company.vue": [
		13582,
		[]
	],
	"./page/CompanyAdd.vue": [
		10145,
		[
			145
		]
	],
	"./page/Conpons.vue": [
		13258,
		[]
	],
	"./page/Customer.vue": [
		995,
		[]
	],
	"./page/CustomerGroup.vue": [
		74235,
		[]
	],
	"./page/CustomerLedger.vue": [
		21383,
		[]
	],
	"./page/Department.vue": [
		9921,
		[]
	],
	"./page/Districts.vue": [
		60628,
		[]
	],
	"./page/Inventory.vue": [
		36451,
		[
			6451
		]
	],
	"./page/Login.vue": [
		6505,
		[]
	],
	"./page/LoginFromApp.vue": [
		57181,
		[]
	],
	"./page/MobileWallet.vue": [
		50641,
		[]
	],
	"./page/NumberToWord.vue": [
		51123,
		[]
	],
	"./page/Outlet.vue": [
		68731,
		[]
	],
	"./page/ProductCategory.vue": [
		79461,
		[]
	],
	"./page/Product_List_Item.vue": [
		67530,
		[
			7530
		]
	],
	"./page/Role.vue": [
		42281,
		[]
	],
	"./page/RolePermission.vue": [
		62514,
		[]
	],
	"./page/Sizes.vue": [
		64974,
		[]
	],
	"./page/Supplier.vue": [
		6029,
		[]
	],
	"./page/SupplierType.vue": [
		91505,
		[]
	],
	"./page/Taxes.vue": [
		15792,
		[]
	],
	"./page/Unit.vue": [
		98752,
		[]
	],
	"./page/User.vue": [
		33590,
		[]
	],
	"./page/Warehouse.vue": [
		51165,
		[]
	],
	"./pos/Autocomplete.vue": [
		23712,
		[
			3712
		]
	],
	"./pos/PosLeftbar-converted.vue": [
		23432,
		[
			3432
		]
	],
	"./pos/PosLeftbar.vue": [
		6937,
		[]
	],
	"./pos/PosRightbar.vue": [
		2718,
		[]
	],
	"./pos/Product_List_Item.vue": [
		67396,
		[]
	],
	"./pos_report/CollectionReport.vue": [
		78794,
		[
			8794
		]
	],
	"./pos_report/DailySalesReport.vue": [
		79000,
		[
			9000
		]
	],
	"./pos_report/DailySummaryReport.vue": [
		78614,
		[
			8614
		]
	],
	"./pos_report/InventoryDetailsReport.vue": [
		50449,
		[
			449
		]
	],
	"./pos_report/InventorySummary.vue": [
		17064,
		[
			7064
		]
	],
	"./pos_report/LowStockReport.vue": [
		6549,
		[
			6549
		]
	],
	"./pos_report/ProductPurchaseReport.vue": [
		63910,
		[
			3910
		]
	],
	"./pos_report/ProductSalesReport.vue": [
		84283,
		[
			4283
		]
	],
	"./pos_report/PurchaseReport.vue": [
		42926,
		[
			2926
		]
	],
	"./pos_report/SaleReport.vue": [
		4978,
		[
			4978
		]
	],
	"./pos_report/StockReport.vue": [
		63185,
		[
			3185
		]
	],
	"./procurement/Approvals.vue": [
		41717,
		[
			1717
		]
	],
	"./procurement/Dashboard.vue": [
		6316,
		[
			6316
		]
	],
	"./procurement/PurchaseOrders.vue": [
		73145,
		[
			3145
		]
	],
	"./procurement/PurchaseRequisitions.vue": [
		64913,
		[
			4913
		]
	],
	"./procurement/PurchaseReturns.vue": [
		4633,
		[
			4633
		]
	],
	"./procurement/Suppliers.vue": [
		375,
		[
			375
		]
	],
	"./procurement/VendorBills.vue": [
		50204,
		[
			204
		]
	],
	"./product/BarcodeDemo.vue": [
		21469,
		[]
	],
	"./product/Bulkupload.vue": [
		65498,
		[]
	],
	"./product/Product.vue": [
		92666,
		[]
	],
	"./product/Product_List_Item.vue": [
		39474,
		[
			9474
		]
	],
	"./purchase/Approvals.vue": [
		32862,
		[
			2862
		]
	],
	"./purchase/BackupWarehousePurchaseReceive.vue": [
		11648,
		[
			1648
		]
	],
	"./purchase/PurchaseOrder.vue": [
		98477,
		[]
	],
	"./purchase/PurchaseOrderApprovalList.vue": [
		96637,
		[]
	],
	"./purchase/PurchaseOrderEdit.vue": [
		96360,
		[]
	],
	"./purchase/PurchaseOrderList copy.vue": [
		41804,
		[
			1804
		]
	],
	"./purchase/PurchaseOrderList.vue": [
		83716,
		[]
	],
	"./purchase/PurchaseReceive.vue": [
		16913,
		[]
	],
	"./purchase/PurchaseReceiveBoard.vue": [
		22370,
		[]
	],
	"./purchase/PurchaseReceiveHaveRemoveIssue.vue": [
		60466,
		[
			466
		]
	],
	"./purchase/PurchaseReceiveList.vue": [
		91997,
		[]
	],
	"./purchase/QualityControl.vue": [
		22204,
		[
			2204
		]
	],
	"./purchase/RFQ.vue": [
		12177,
		[]
	],
	"./purchase/VendorBills.vue": [
		66513,
		[
			6513
		]
	],
	"./purchase/VendorPerformance.vue": [
		95558,
		[]
	],
	"./purchase/WarehousePurchaseReceive.vue": [
		67223,
		[]
	],
	"./purchase_requisition/StorePurchaseRequisition.vue": [
		71934,
		[]
	],
	"./purchase_requisition/StorePurchaseRequisitionEdit.vue": [
		78241,
		[]
	],
	"./purchase_requisition/StoreRequisitionApprovalList.vue": [
		73684,
		[]
	],
	"./purchase_requisition/StoreRequisitionList.vue": [
		3264,
		[]
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrder.vue": [
		17586,
		[]
	],
	"./purchase_requisition/StoreRequisitionPurchaseOrderEdit.vue": [
		35184,
		[]
	],
	"./purchase_return/PurchaseReturn.vue": [
		35131,
		[
			5131
		]
	],
	"./purchase_return/PurchaseReturnList.vue": [
		42172,
		[
			2172
		]
	],
	"./reports/AuditLogs.vue": [
		70555,
		[]
	],
	"./reports/BalanceSheet.vue": [
		22832,
		[
			2832
		]
	],
	"./reports/BankBook.vue": [
		2246,
		[
			2246
		]
	],
	"./reports/CashAndBankBook.vue": [
		64248,
		[
			4248
		]
	],
	"./reports/CashBook.vue": [
		21991,
		[
			1991
		]
	],
	"./reports/DailyTransaction.vue": [
		77745,
		[
			7745
		]
	],
	"./reports/LedgerReport.vue": [
		36565,
		[
			6565
		]
	],
	"./reports/ProfitLoss.vue": [
		6874,
		[
			6874
		]
	],
	"./reports/TrialBalance.vue": [
		24520,
		[
			4520
		]
	],
	"./rewards-points/OrderTatalPoints.vue": [
		18943,
		[]
	],
	"./rewards-points/OrderTotalPoints.vue": [
		78557,
		[
			8557
		]
	],
	"./rewards-points/PointsSettings.vue": [
		21236,
		[]
	],
	"./rewards-points/RewardsPoints.vue": [
		21218,
		[]
	],
	"./sales/DiscountSettings.vue": [
		33320,
		[]
	],
	"./sales/DueSales.vue": [
		60993,
		[
			993
		]
	],
	"./sales/HoldSales.vue": [
		88126,
		[
			5895,
			8126
		]
	],
	"./sales/LoyaltySettings.vue": [
		36946,
		[
			6946
		]
	],
	"./sales/PosSales.vue": [
		50753,
		[]
	],
	"./sales/SalesReturn.vue": [
		92764,
		[
			5895,
			2764
		]
	],
	"./sales_account_posting/SalesAccountPosting.vue": [
		29754,
		[
			9754
		]
	],
	"./settings/GeneralSettings.vue": [
		19639,
		[
			9639
		]
	],
	"./stock/DamageProductManagement.vue": [
		60408,
		[
			408
		]
	],
	"./stock/StockInOut.vue": [
		51802,
		[]
	],
	"./stock/StockManagement.vue": [
		75456,
		[]
	],
	"./stock/WarehouseStockManagement.vue": [
		61198,
		[
			1198
		]
	],
	"./stock_transfer/StockTransfer.vue": [
		48525,
		[]
	],
	"./stock_transfer/StockTransferList.vue": [
		25180,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 94235;
module.exports = webpackAsyncContext;